module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "media"
  }, [(_vm.beatmaps[_vm.game.BeatmapID]) ? _c('figure', {
    staticClass: "media-left"
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "max-height": "220px"
    },
    attrs: {
      "src": 'https://b.ppy.sh/thumb/' + _vm.beatmaps[_vm.game.BeatmapID].beatmapset_id + 'l.jpg'
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.game.Name))]), _c('br'), _vm._v(" "), (_vm.beatmaps[_vm.game.BeatmapID]) ? _c('span', [_c('span', {
    class: 'osu-icon mode-' + _vm.game.GameMode
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'https://ripple.moe/b/' + _vm.game.BeatmapID,
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.beatmaps[_vm.game.BeatmapID].song_name) + "\n          ")]), _vm._v("\n          " + _vm._s(_vm.scoreMods(_vm.game.Mods)) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, _vm._l((_vm.scoresSorted), function(uid) {
    return _c('user-score', {
      key: uid,
      attrs: {
        "uid": uid,
        "score": _vm.game.Scores[uid],
        "users": _vm.users
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_c('timeago', {
    attrs: {
      "auto-update": 30,
      "since": _vm.game.CreatedAt,
      "title": _vm.game.CreatedAt
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4b4c798","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 149
// module chunks = 1